<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <b-form-textarea
                id="textarea"
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :placeholder="field.placeholder"
                rows="3"
                max-rows="3"
                :disabled="loading || isDisable"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                    'is-invalid': isInvalid,
                }"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField,
    data() {
        return {
            isInvalid: '',
            isDisable: false,
        }
    }, // End of Component > extends

    created() {
        if (this.field.key == 'pepInfo.declarationPEP8') {
            // //console.log(this.$store.state.registration.form.pepInfo)
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.pepInfo
                },
                (newValue, oldValue) => {
                    // //console.log(newValue)
                    for (let key in newValue) {
                        if (newValue.hasOwnProperty(key)) {
                            //console.log(key + ' -> ' + newValue[key])
                            if (newValue[key] == 'Yes') {
                                this.field.isRequired = true
                                this.isInvalid = true
                                break
                            } else {
                                this.field.isRequired = false
                                this.isInvalid = false
                            }
                        }
                    }
                    // //console.log(this.$store.state.registration.form.pepInfo)
                },
                {
                    deep: true,
                }
            )
        }

        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason1') {
            this.isDisable = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo
                        .crsReason1
                },
                (newValue) => {
                    if (
                        newValue == 'Unable to obtain a TIN/Equivalent Number '
                    ) {
                        //console.log(newValue)
                        //console.log(this.field.status)
                        this.isDisable = false
                    } else {
                        this.isDisable = true
                    }
                }
            )
        } // End
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason2') {
            this.isDisable = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo
                        .crsReason2
                },
                (newValue) => {
                    if (
                        newValue == 'Unable to obtain a TIN/Equivalent Number '
                    ) {
                        //console.log(newValue)
                        //console.log(this.field.status)
                        this.isDisable = false
                    } else {
                        this.isDisable = true
                    }
                }
            )
        } // End
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason3') {
            this.isDisable = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo
                        .crsReason3
                },
                (newValue) => {
                    if (
                        newValue == 'Unable to obtain a TIN/Equivalent Number '
                    ) {
                        //console.log(newValue)
                        //console.log(this.field.status)
                        this.isDisable = false
                    } else {
                        this.isDisable = true
                    }
                }
            )
        } // End
    },
}
</script>
